import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/github/workspace/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "kinsokutype"
    }}>{`KinsokuType`}</h1>
    <p>{`Kinsoku processing options.`}</p>
    <h2 {...{
      "id": "class"
    }}>{`Class`}</h2>
    <blockquote>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`Number `}<strong parentName="p">{`KINSOKU_PUSH_IN_FIRST`}</strong>{` = 1248553318`}</p>
      <p parentName="blockquote">{`Attempts to move characters to the previous line; if the push-in is not possible, pushes characters to the next line.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`Number `}<strong parentName="p">{`KINSOKU_PUSH_OUT_FIRST`}</strong>{` = 1248554854`}</p>
      <p parentName="blockquote">{`Attempts to move characters to the next line; if the push-out is not possible, pushes characters to the previous line.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`Number `}<strong parentName="p">{`KINSOKU_PUSH_OUT_ONLY`}</strong>{` = 1248554863`}</p>
      <p parentName="blockquote">{`Always moves characters to the next line. Does not attempt a push-in.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`Number `}<strong parentName="p">{`KINSOKU_PRIORITIZE_ADJUSTMENT_AMOUNT`}</strong>{` = 1248553313`}</p>
      <p parentName="blockquote">{`The kinsoku prioritize adjustment amount.`}</p>
    </blockquote>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      